var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpacesApi } from './apis/spaces-api.interface';
let PinSpaceRepositoryImpl = class PinSpaceRepositoryImpl {
    constructor(_spacesApi) {
        this._spacesApi = _spacesApi;
    }
    pinSpace(spaceId, isPin) {
        if (isPin) {
            return this._spacesApi.stickSpace(spaceId);
        }
        else {
            return this._spacesApi.unstickSpace(spaceId);
        }
    }
};
PinSpaceRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesApi !== "undefined" && SpacesApi) === "function" ? _a : Object])
], PinSpaceRepositoryImpl);
export { PinSpaceRepositoryImpl };
